<ng-container *ngIf="isLoading; else pageContent">
  <div class="app-spinner">
    <mat-spinner diameter="50"></mat-spinner>
  </div>
</ng-container>

<ng-template #pageContent>
  <ng-container *ngIf="jobSubmitted; else showMessage">
    <div class="success-page">
      <div class="success-card">
        <div class="success-icon">
          <i class="bi bi-check-lg"></i>
        </div>

        <h1>Application submitted successfully</h1>

        <p class="job-name">
          {{ jobSubmitted.job_title }}
          at
          {{ jobSubmitted.company_name }}
        </p>
      </div>

    <div class="next-step-card" *ngIf="buttonText">
      <div class="next-step-left">
        <div class="next-step-icon">
          <i
            class="bi"
            [ngClass]="buttonText === 'Start Assessment' ? 'bi-clipboard2-check' : 'bi-camera-video'">
          </i>
        </div>
        <div class="next-step-content">
          <h3>Next step: {{ title }}</h3>
          <p> {{ description }}</p>
        </div>
      </div>
      <button class="next-step-btn" (click)="startNextStep()"> {{ buttonText }} </button>
    </div>
      <div class="progress-card">
        <div class="progress-header">
          <h2>Your hiring progress</h2>

          <span>
            Stage {{ getCurrentStageNumber() }} of
            {{ (jobSubmitted.hiring_process.length || 0) + 1 }}
          </span>
        </div>

        <div class="progress-tracker">
          <div class="tracker-line"></div>
          
          <div class="tracker-steps">
            <div class="tracker-step active">
              <div class="tracker-icon-container">
                <div class="tracker-icon">
                  <i class="bi bi-check2"></i>
                </div>
              </div>
              <span class="tracker-label">Applied</span>
            </div>

            <div class="tracker-step" *ngFor="let step of jobSubmitted.hiring_process" [class.active]="isStepCompleted(step)">
              <div class="tracker-icon-container">
                <div class="tracker-icon">
                  <i [class]="getStageIcon(step)"></i>
                </div>
              </div>
              <span class="tracker-label">{{ getStageLabel(step) }}</span>
            </div>
          </div>
        </div>

        <div class="step-list">
          <div class="step-item active">
            <div class="step-icon">
              <i class="bi bi-check-circle"></i>
            </div>
            <div class="step-content">
              <h4>Application Submitted</h4>
              <p>
                Your application has been submitted successfully.
              </p>
            </div>
          </div>

          <div class="step-item" *ngFor="let step of jobSubmitted.hiring_process; let i = index" [class.active]="isStepCompleted(step)">
            <div class="step-icon" [ngClass]="isStepCompleted(step) ? 'primary' : 'gray'">
              <i [class]="getStageIcon(step)"></i>
            </div>
            <div class="step-content">
              <h4>Step {{ i + 1 }} – {{ getStageTitle(step) }}</h4>
              <p>{{ getStageDescription(step) }}</p>
            </div>
          </div>
        </div>

        <div class="info-box">
          <i class="bi bi-shield-check"></i>
          <span>
            Note: All stages are AI-proctored to ensure a fair and secure hiring process. Suspicious activity, such as frequent tab switching or prolonged absence, may invalidate your attempt.
          </span>
        </div>
      </div>

      <div class="success-actions">
        <button class="primary-btn" type="button" (click)="goToMyApplicationPage()">
          Go to my applications
        </button>
        <button class="secondary-btn" type="button" (click)="goToJobHome()">
          Apply to more jobs
        </button>
      </div>
    </div>
  </ng-container>

  <ng-template #showMessage>
    <p>No data available</p>
  </ng-template>
</ng-template>